function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7273 23C46.716 23 49.081 20.5326 49.081 16.4417C49.081 12.3636 46.716 9.90906 42.8168 9.90906H38.2913V23H42.7273ZM40.6627 20.9481V11.9609H42.6826C45.3417 11.9609 46.7288 13.4439 46.7288 16.4417C46.7288 19.4524 45.3417 20.9481 42.6123 20.9481H40.6627Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.092 9.90906H59.7334V18.8324H59.6183L53.4564 9.90906H51.3342V23H53.7057V14.0831H53.8143L59.9827 23H62.092V9.90906Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M75.4338 9.90906H73.0752V18.8324H72.9601L66.7982 9.90906H64.676V23H67.0475V14.0831H67.1561L73.3245 23H75.4338V9.90906Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M80.7408 23.1981C82.2813 23.1981 83.2018 22.4758 83.6236 21.6512H83.7003V23H85.9248V16.4289C85.9248 13.8338 83.809 13.0539 81.9361 13.0539C79.8715 13.0539 78.2863 13.9744 77.7749 15.7642L79.9354 16.071C80.1655 15.3998 80.8175 14.8245 81.9489 14.8245C83.0228 14.8245 83.6109 15.3743 83.6109 16.3395V16.3778C83.6109 17.0426 82.9141 17.0745 81.1819 17.2599C79.2771 17.4645 77.4553 18.0333 77.4553 20.245C77.4553 22.1754 78.868 23.1981 80.7408 23.1981ZM81.3417 21.4978C80.3765 21.4978 79.6861 21.0568 79.6861 20.2066C79.6861 19.3181 80.4596 18.9474 81.4951 18.8004C82.1023 18.7173 83.3168 18.5639 83.6173 18.321V19.4779C83.6173 20.571 82.7352 21.4978 81.3417 21.4978Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M92.5981 23.1917C94.8864 23.1917 96.4589 22.0731 96.868 20.3664L94.7075 20.1235C94.3942 20.9545 93.6272 21.3892 92.63 21.3892C91.1343 21.3892 90.1435 20.4048 90.1244 18.7237H96.9638V18.0142C96.9638 14.5689 94.8928 13.0539 92.4766 13.0539C89.6641 13.0539 87.8296 15.1186 87.8296 18.1484C87.8296 21.2294 89.6386 23.1917 92.5981 23.1917ZM90.1307 17.164C90.2011 15.9112 91.1279 14.8565 92.5086 14.8565C93.8381 14.8565 94.733 15.8281 94.7458 17.164H90.1307Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#297AF7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.62 22.302V9H17.372C18.56 9 19.592 9.18 20.468 9.54C21.356 9.888 22.094 10.368 22.682 10.98C23.282 11.58 23.726 12.264 24.014 13.032C24.314 13.8 24.464 14.598 24.464 15.426V15.822C24.464 16.614 24.314 17.394 24.014 18.162C23.726 18.93 23.282 19.626 22.682 20.25C22.094 20.874 21.356 21.372 20.468 21.744C19.592 22.116 18.56 22.302 17.372 22.302H12.62ZM17.534 11.376H15.176V19.926H17.534C18.434 19.926 19.208 19.746 19.856 19.386C20.504 19.014 21.002 18.504 21.35 17.856C21.698 17.208 21.872 16.464 21.872 15.624C21.872 14.316 21.488 13.284 20.72 12.528C19.952 11.76 18.89 11.376 17.534 11.376Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 13,
  r: 2,
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 20,
  r: 2,
  fill: "white"
});

function SvgFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 32,
    viewBox: "0 0 97 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.b476b09c.svg";
export { ForwardRef as ReactComponent };